/**
 * Append a parenthesised count to a label: `withCount('All Labels', 32)` →
 * `'All Labels (32)'`. Anything but a finite number (counts still loading,
 * nothing extracted yet) returns the label unchanged, so callers pass `null`
 * to hide the count.
 */
export const withCount = (label, count) =>
    Number.isFinite(count) ? `${label} (${count})` : label;
